<template>
<section class="site chat">
        <article class="content-area">
            <header class="chathead">
          <button class="secondary"><router-link to="/profile">save and exit</router-link></button>
        
          <p :class="activeSituation">My Situation <span>Clarifying the facts about my condition</span></p>
          <p :class="activeOptions">My Options <span>Clarifying my treatment options</span></p>
          <p :class="activeSupport">My Support <span>Clarifying who can help me</span></p>
          <p :class="activeGoals">My Goals <span>Clarifying what's important to me</span></p>
          <p :class="activeEvaluation">My Questions and Concerns <span>Clarifying what I want to discuss with my doctor</span></p>
        
        </header>   

            <main>
     <section class="chatbot">
    <chatbot ref="chatbot" :conversationDescription="conversation"></chatbot>



        <div class="message">chatbot</div>
        <div class="message">chatbot</div>
        <div class="message-response">person person person person person person person person person person person person person person person person person person person person person person person</div>
        <div class="message">chatbot</div>
       <div data-v-0807e744="" class="question"><span data-v-0807e744=""><button data-v-0807e744="">I do have questions</button></span><span data-v-0807e744=""><button data-v-0807e744="">I don't have any questions right now</button></span></div>
        <div class="message">person person person person person person perperson person person person person person per</div>
        <div class="message">chatbot</div>
        <div class="message-response">person pperson person person person person person person person person person person person person person person person</div>
        <div class="message">chatbot</div>
       <div data-v-0807e744="" class="question"><span data-v-0807e744=""><button data-v-0807e744="">I do have questions</button></span><span data-v-0807e744=""><button data-v-0807e744="">I don't have any questions right now</button></span></div>
        <div class="message">chatbot</div>
        <div class="message">chatbot</div>
        <div class="message-response">person rson person person person person person person person person person person person person</div>
        <div class="message">chatbot</div>
       <div data-v-0807e744="" class="question"><span data-v-0807e744=""><button data-v-0807e744="">I do have questions</button></span><span data-v-0807e744=""><button data-v-0807e744="">I don't have any questions right now</button></span></div>
        <div class="message">chatbot</div>
        <div class="message">chatbot</div>
        <div class="message-response">person person person person person person person person person person person person person person person person person person person person person person person</div>
        <div class="message">chatbot</div>
       <div data-v-0807e744="" class="question"><span data-v-0807e744=""><button data-v-0807e744="">I do have questions</button></span><span data-v-0807e744=""><button data-v-0807e744="">I don't have any questions right now</button></span></div>
        <div class="message">chatbot</div>
        <div class="message">chatbot</div>
        <div class="message-response">person person person person person person person person person person person person person person person person person person person person person person person</div>
        <div class="message">chatbot</div>
       <div data-v-0807e744="" class="question"><span data-v-0807e744=""><button data-v-0807e744="">I do have questions</button></span><span data-v-0807e744=""><button data-v-0807e744="">I don't have any questions right now</button></span></div>
        <div class="message">chatbot</div>
        <div class="message">chatbot</div>
        <div class="message-response">person person person person person person person person person person person person person person person person person person person person person person person</div>
        <div class="message">chatbot</div>
       <div data-v-0807e744="" class="question"><span data-v-0807e744=""><button data-v-0807e744="">I do have questions</button></span><span data-v-0807e744=""><button data-v-0807e744="">I don't have any questions right now</button></span></div>
        <div class="message">chatbot</div>
        <div class="message">chatbot</div>
        <div class="message-response">person person person person person person person person person person person person person person person person person person person person person person person</div>
        <div class="message">chatbot</div>
       <div data-v-0807e744="" class="question"><span data-v-0807e744=""><button data-v-0807e744="">I do have questions</button></span><span data-v-0807e744=""><button data-v-0807e744="">I don't have any questions right now</button></span></div>

    </section>            


<site-aside></site-aside>

            </main>
        </article>
    
 </section>
</template>

<style scoped lang="scss">
	.chathead p.active{
	
		&+p+p{opacity:.8;}
		&+p+p+p{opacity:.5;}
		&+p+p+p+p{opacity:.2;}
  } 
  
.site.chat {
  grid-template-columns: 1fr 11fr;
  grid-template-areas:". content-area";

  .content-area {
    display: grid;
    grid-template-columns: 1fr 5fr;
    grid-column-gap: 1rem;
    grid-template-areas: "chathead chatbot";
    padding:0 0 0 1rem;

    main {
	    display: flex;
	    align-items: flex-start;
      height: 99vh;
      overflow-y: scroll;
      margin:0;
    }
    aside.pattern {
     
      
    }
  }

}
.chatbot {
  
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height:auto;
  padding:0 4rem 0 1rem;
}


</style>

<script>
import { mapMutations } from 'vuex';
import ChatBot from "@/components/ChatBot.vue";
import { conversations } from "@/assets/conversations/index.js";
import SiteAside from '@/components/SiteAside.vue';

export default {
  name: "mychat",

  props: {
    section: String
  },

  data() {
    return {
      conversations: conversations,
      debug: false
    }
  },

  methods: {
    ...mapMutations(['resetSituation', 'resetOptions', 'resetNetwork', 'resetGoals', 'resetEvaluation']),

    toggleDebug() {
      this.debug = !this.debug;
    }
  },
  
  computed: {
    debugStyle() {
      if (this.debug) {
        return "display: block;";
      }
      else {
        return "display: none;";
      }
    },

    conversation() {
      switch (this.section) {
       case "situation":
          return this.conversations.MySituation;
          break;
 
        case "options":
          return this.conversations.MyOptions;
          break;
        
        case "network":
          return this.conversations.MyNetwork;
          break;

        case "goals":
          return this.conversations.MyGoals;
          break;

        case "evaluation":
          return this.conversations.Evaluation;
          break;
      }

      return undefined;
    },
    
    activeSituation: function() {
  		return this.section == "situation" ? "active" : "";
  	},
  	activeOptions: function() {
  		return this.section == "options" ? "active" : "";
  	},
  	activeSupport: function() {
  		return this.section == "network" ? "active" : "";
  	},
  	activeGoals: function() {
  		return this.section == "goals" ? "active" : "";
  	},
  	activeEvaluation: function() {
  		return this.section == "evaluation" ? "active" : "";
  	}

  },
  components: {
    "chatbot": ChatBot,
    "site-aside": SiteAside,  }
};
</script>
